export default "__VITE_ASSET__CqlD7vOf__"